export enum AttachEvent {
  Click,
  Hover,
  Automatically,
}
